<template>
    <div>
        <div class="card-body" v-if="visits.length > 0">
            <table class="table">
                <thead>
                <tr>
                    <th></th>
                    <th>Datum / čas<br>Klient</th>
                    <th></th>
                    <th>Důvod návštěvy</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <template v-for="(visit, index) in (visits)" class="card-text">
                    <tr>
                        <td rowspan="2" class="align-middle">
                            <i class="fa fa-2x fa-circle-o text-info" aria-hidden="true" v-if="visit.state === 'scheduled'"></i>
                            <i class="fa fa-2x fa-clock-o text-success" aria-hidden="true" v-else-if="visit.state === 'arrived'"></i>
                            <i class="fa fa-2x fa-check-circle text-success" aria-hidden="true" v-else-if="visit.state === 'completed'"></i>
                            <i class="fa fa-2x fa-dot-circle-o text-warning" aria-hidden="true" v-else-if="visit.state === 'elaborated'"></i>
                            <i class="fa fa-2x fa-times-circle-o text-danger" aria-hidden="true" v-else-if="visit.state === 'failed'"></i>
                            <i class="fa fa-2x fa-dot-circle-o text-danger" aria-hidden="true" v-else-if="visit.state === 'excused'"></i>
                            <i class="fa fa-2x fa-times-circle text-danger" aria-hidden="true" v-else-if="visit.state === 'canceled'"></i>
                            <!--<visit-change-state v-on:update="getDoctorsDayVisits" :actual-state="visit.state" :selected-doctor-id="visit.planned_for.id" :visit-id="visit.id"></visit-change-state>-->
                        </td>
                        <td class="align-middle">
                            <template v-if="visit.hasData">
                                <button @click="showHideVisitDetail(index)" class="btn btn-sm btn_extra_small btn-primary"><i class="fa fa-info-circle" aria-hidden="true"></i></button>
                            </template>
                            {{ visit.date }} od {{visit.timeFrom}} do {{visit.timeTo}}
                        </td>
                        <td>

                        </td>
                        <td colspan="2" class="align-middle">
                            <b>{{ visit.visit_purpose.purpose }}</b>
                            <i>poznámka: {{  visit.note }}</i>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="3" class="border-top-0">
                            <!--<router-link class="text-secondary" :to="{ name: 'ShowClient', params: { clientid: visit.client.id }}"><i class="fa fa-address-card-o" aria-hidden="true"></i></router-link> {{ visit.client.first_name }} {{ visit.client.last_name }} - {{ visit.client.p_i_n }}-->
                            <!--<span class="badge badge-secondary" v-if="visit.client.health_insurance">{{ visit.client.health_insurance.code }}</span>
                            <span class="badge badge-warning" v-else=""><i class="fa fa-warning" aria-hidden="true"></i> chybí zdrav. pojišťovna</span>
                            <span class="badge badge-primary" v-if="visit.client.membership">{{ visit.client.membership.name }}</span>
                            <span class="badge badge-warning" v-else=""><i class="fa fa-warning" aria-hidden="true"></i> nemá program</span>
                            <span class="badge badge-warning" v-if="visit.client.missing_data"><i class="fa fa-danger" aria-hidden="true"></i> chybějící údaje</span>
                            <span class="badge badge-warning" v-if="visit.client.missing_contact"><i class="fa fa-danger" aria-hidden="true"></i> chybějící kontakty</span>-->
                        </td>
                        <td colspan="1" class="border-top-0 text-right">
                            <template v-if="visit.state === 'scheduled'">
                                <button class="btn btn-sm btn-warning" @click="showModalClientVisitChange(visit.id)"><i class="fa fa-calendar-plus-o" aria-hidden="true"></i> přeobjednat</button>
                                <button class="btn btn-sm btn-danger" @click="cancelVisit(visit.id)"><i class="fa fa-calendar-times-o" aria-hidden="true"></i> zrušit návštěvu</button>
                            </template><br>
                            {{ visit.planned_for.fullname }}
                            <!-- <visit-change-doctor v-on:update="getDoctorsDayVisits" :doctors="doctors" :selected-doctor-id="visit.planned_for.id" :visit-id="visit.id"></visit-change-doctor> -->
                        </td>
                    </tr>
                    <tr v-if="showedVisitDetail.indexOf(index) > -1">
                        <td class="border-top-0">

                        </td>
                        <td class="" colspan="2">
                            <div class="" v-if="visit.medical_report">
                                <h6>Výsledná zpráva</h6>
                                <div v-html="visit.medical_report.text"></div>
                            </div>
                        </td>
                        <td class="" colspan="2">
                            <div class="">
                                <h6>Diagnózy a výkony</h6>
                                <div>
                                    <table class="table">
                                        <tbody>
                                        <template v-for="diagnose in visit.diagnosis">
                                            <tr>
                                                <td>{{ diagnose.disease.code }}</td>
                                                <td>{{ diagnose.disease.name_cs }}</td>
                                            </tr>
                                            <template v-if="diagnose.actions.length > 0">
                                                <tr v-for="action in diagnose.actions">
                                                    <td></td>
                                                    <td>
                                                        {{ action.operation.code }} - {{ action.operation.name }}
                                                    </td>
                                                </tr>
                                            </template>
                                            <template v-else="">
                                                <tr>
                                                    <td></td>
                                                    <td>
                                                        <i>(diagnóza nemá přidělené výkony)</i>
                                                    </td>
                                                </tr>
                                            </template>
                                        </template>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="">
                                <h6>Léčiva</h6>
                                <div>
                                    <template v-if="visit.medicament.length > 0">
                                        <table class="table">
                                            <tbody>
                                            <tr v-for="m in visit.medicament">
                                                <td>{{ m.medicine ? m.medicine.label : '' }}
                                                  {{ m.individual_medicine ? m.individual_medicine.name : '' }}</td>
                                                <td>{{ m.dosage }}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </template>
                                    <template v-else="">
                                        <i>žádný lék nepředepsán</i>
                                    </template>
                                </div>
                            </div>
                        </td>
                    </tr>
                </template>
                </tbody>
            </table>
        </div>
        <div class="card-body" v-else-if="visitsPending">
            <div class="text-center">
                <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i><br/>
                (načítám)
            </div>
        </div>
        <div class="card-body" v-else="">
            <div class="text-center">
                <i class="fa fa-frown-o fa-3x"></i><br/>
                (na tento den není nic naplánováno)
            </div>
        </div>
        <client-visit-change :opened="modalChangeVisitOpened" :visit-id="modalChangeVisitId" v-on:update="updateVisits"></client-visit-change>
    </div>
</template>

<script>
  import ClientVisitChange from '../modals/ChangeVisit.vue'
  import apiMixin from '@/mixins'

  export default {
    data () {
      return {
        selectedStates: [
          'scheduled',
          'arrived',
          'elaborated'
        ],
        setting: require('../../../variables.js'),
        visits: [],
        visitsPending: false,
        visitsError: false,
        past_visits: '',
        show_past_visits: false,
        neco_se_stalo_s_id: '',
        modalChangeVisitOpened: false,
        modalChangeVisitId: null,
        changePending: false,
        update_visit: {},
        showedVisitDetail: []
      }
    },
    mixins: [apiMixin],
    props: ['doUpdate'],
    methods: {
      showHideVisitDetail (index) {
        if (this.showedVisitDetail.indexOf(index) === -1) {
          this.showedVisitDetail.push(index)
        } else {
          this.showedVisitDetail.splice(this.showedVisitDetail.indexOf(index), 1)
        }
      },
      showPastVisits () {
        this.show_past_visits = true
        if (this.past_visits === '') {
          this.getClientsPastVisits()
        }
      },
      cancelVisit (visitId) {
        this.changePending = true
        this.update_visit.state = 'canceled'
        this.$http.put('visit/' + visitId, this.update_visit, {emulateJSON: true}).then(response => {
          this.submited = response.data
          this.changePending = false
          this.updateVisits('home')
        }).catch(error => {
          this.changeError = error.response.data.errors
          this.changePending = false
        })
      },
      hidePastVisits () {
        this.show_past_visits = false
      },
      changeState (id) {
        this.neco_se_stalo_s_id = id
      },
      clientVisitsUpdated () {
        this.$emit('updated')
      },
      showModal (name) {
        this.$modal.show(name)
      },
      showModalClientVisitChange (visitId) {
        this.modalChangeVisitOpened = true
        this.modalChangeVisitId = visitId
        this.showModal('client-visit-change')
      },
      updateVisits () {
        this.getClientsVisits(this.selectedStates, this.$route.params.clientid)
        /* this.getClientsUpcomingVisits()
        if (this.show_past_visits === true || this.past_visits !== '') {
          this.getClientsPastVisits()
        }
        this.clientVisitsUpdated() */
      }
    },
    beforeMount () {
      this.updateVisits()
    },
    watch: {
      doUpdate (val) {
        if (val === true) {
          this.updateVisits()
        }
      },
      selectedStates: function () {
        this.updateVisits()
      },
      '$route' (to, from) {
        if (to.params.clientid !== from.params.clientid && typeof (to.params.clientid) !== 'undefined') {
          this.updateVisits()
        }
      }
    },
    components: {
      ClientVisitChange
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Client/components/ClientMessage.vue?ae291982